import Invitations from "./invitations"

export default Invitations
